import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FreelancerFilter } from '../interfaces/filters';
import { ListFreelancersComponent } from '../list-freelancers/list-freelancers.component';
import { ListFreelancersService } from '../services/list-freelancers.service';
// import { ApplyStatusService } from '../services/apply-status.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-search-freelancers',
  templateUrl: './search-freelancers.component.html',
  styleUrls: ['./search-freelancers.component.css']
})

export class SearchFreelancersComponent implements OnInit, OnDestroy {
  loaded: boolean;
  optionsModel: number[];

  freelancers: any;
  errorMessage: string;

  form: FormGroup;
  countReq: number;
  subscription: Subscription;
  advancedSearch: boolean;

  @ViewChild(ListFreelancersComponent) listFreelancersComponent: ListFreelancersComponent;

  // public STATUS = Constants;

  constructor(private route: ActivatedRoute,
              private _router: Router,
              private fb: FormBuilder,
              private listFreelancersService: ListFreelancersService,
              // private applyStatusService: ApplyStatusService,
              public dialog: MatDialog) {
    this.subscription = listFreelancersService.freelancersCountChanged$.subscribe(event => {
    });
  }

  ngOnInit() {
    this.advancedSearch = false;
    this.form = this.fb.group({
      name: [''],
      email: [''],
      query: [''],
      query_skill: [''],
      query_edu: [''],
      query_exp: [''],
      jobId: [''],
      jobName: [''],
      filters: this.fb.group({
        favorite: [''],
        read: [''],
        unread: [''],
        rejected: [''],
        screening: [''],
        interview: [''],
        test: [''],
        selected: [''],
        hired: [''],
        custom: ['']
      })
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onChange($event) {
    console.log(this.optionsModel);
  }

  updateFilters(filters: FreelancerFilter, valid: boolean) {
    if (valid) {
      this.listFreelancersComponent.refreshListing(1);
    }
  }

  onAdvanceSearch() {
    if (this.advancedSearch) {
      this.advancedSearch = false;
    } else {
      this.advancedSearch = true;
    }
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data:
      {message: 'Buscador de Freelancers', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/search-freelancers/search-freelancers.component.ts